import { render, staticRenderFns } from "./GenericCampaignDetails.vue?vue&type=template&id=5cd7f94a&"
import script from "./GenericCampaignDetails.vue?vue&type=script&lang=ts&"
export * from "./GenericCampaignDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports